<template>
<section class="dealer_select" style="min-height:calc(100vh - 49px); background:#fff">
    <div class="wrap" style="border: none; padding-top: 0;">
        <ul class="menu_ul onenone notice_list">
            <li v-for="(qna) in QnaItems" :key="`qna-find-list-item-${qna.id}`">
                <router-link :to="`/qna/${qna.id}`">
                    <dl>
                        <dt>{{qna.title}}</dt>
                        <dd>{{qna.createDt}}<span :class="{'answer_ok': (qna.status == QNA_STATUS.COMPLETE.id) }">{{qnaStatus(qna.status)}}</span></dd>
                    </dl>
                </router-link>
            </li>
        </ul>
        <button class="onenone_btn" @click="$router.push('/qna/create')">1:1문의<br>쓰기</button> 
    </div>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { FaqFormatMixin } from '../../mixins/FaqFormatMixin';

export default {
    name:'QnaList',
    mixins:[FaqFormatMixin],
    data() {
        return {
            filters: {...this.$store.state.qna.filters},
        }
    },
    async created () {
        this.$store.state.qna.filters.userId = this.$store.state.auth.item.id;
        await this.$store.dispatch('GET_QNA_LIST', {
            dtype: this.QNA_DTYPE.CUSTOMER.id,
        });
        this.$store.commit('SHOW_ONLOAD');
    },
    computed: {
        ...mapState({
            QnaItems : state => state.qna.items,
            QNA_DTYPE: state => state.codeDictionary.items.QNA_DTYPE,
        }),
    },
    methods: {},
}
</script>

<style lang="scss" scoped>

</style>